The replay status to filter by.

See the `WebhookSubscriptionReplay.statusCode` documentation for a list of possible status codes.

If this is not provided then replays of all statuses will be returned.
